import type { MDXComponents } from 'mdx/types'
import { FeatureGate } from './FeatureGate'

/** Components made available to every MDX doc rendered via MDXProvider. */
export const mdxComponents: MDXComponents = {
  FeatureGate,
}
